module.exports = __webpack_public_path__ + "img/collection-weddingRingsFacetes.e4f8433.webp";